var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#F8F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 627,
    y: 652,
    width: 362,
    height: 362,
    rx: 48,
    transform: "rotate(90 627 652)",
    fill: "#EFF3F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1494,
    y: 69,
    width: 566,
    height: 566,
    rx: 57,
    transform: "rotate(60 1494 69)",
    fill: "#D5E8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBackground);
export default __webpack_public_path__ + "static/media/locationBackground.28fe87a344471f241b35b0b29ce691cf.svg";
export { ForwardRef as ReactComponent };